/**
 * X3 골목 쉼 화면 (핸드오프 15 X3, 결정 65). 카운터에서 「다음에 올게요」 · 차 전 나가기 뒤 머무는 곳 — `/welcome?paused=1`.
 *
 *   골목 사진 꽉 채움(확대 · 걷기 없음, 가게 불빛만) + 아래 그라데이션 → 「불은 켜 둘게. 또 와.」(고운바탕 22/34 700)
 *   → 「순례 이모」 → [가게로 들어가기](54 · 반경 16, 크림 바탕 · 팥 글자) → 「다른 계정으로 로그인」(밑줄, 히트 44)
 *
 * - onboarding_step 은 바꾸지 않습니다. 「가게로 들어가기」 → 짧은 걷기(0.8초, 탭 건너뛰기) → /counter(멈춘 단계부터)
 * - 「다른 계정으로 로그인」 → 로그아웃(세션 지움) → /start
 * - 안드로이드 뒤로 = 앱 종료(/welcome 은 첫 화면, lib/nativeBack.js)
 */
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LINES, POLITE_LINES } from '@config/onboarding/counterScript.js';
import { MEMBERS } from '@config/members/index.js';
import { useSession } from '../../stores/session.js';
import { useDarkChrome } from '../../hooks/useDarkChrome.js';
import { sceneUrl } from './SceneCards.jsx';
import { LampFlicker, WalkIn } from './SceneMotion.jsx';

export const SHORT_WALK_MS = 800;

export function PausedAlley() {
    useDarkChrome();
    const navigate = useNavigate();
    const location = useLocation();
    const logout = useSession((state) => state.logout);
    const [walking, setWalking] = useState(false);
    const L = location.state?.speech === 'polite' ? POLITE_LINES : LINES;
    const enter = () => navigate('/counter', { replace: true });

    if (walking) {
        return (
            <main className="relative mx-auto min-h-dvh max-w-app overflow-hidden bg-text-primary">
                <button
                    type="button"
                    aria-label="가게로 들어가는 중. 누르면 건너뛰어요"
                    onClick={enter}
                    className="absolute inset-0 block"
                >
                    <WalkIn duration={SHORT_WALK_MS} onDone={enter} />
                </button>
            </main>
        );
    }

    return (
        <main className="relative mx-auto flex min-h-dvh max-w-app flex-col overflow-hidden bg-text-primary text-[#FFFDF8]">
            <img
                src={sceneUrl('alley')}
                alt="골목 끝 불 켜진 가게"
                className="absolute inset-0 size-full object-cover"
                style={{ objectPosition: 'center 74%' }}
            />
            <LampFlicker objectPositionY={0.74} />
            <span
                aria-hidden="true"
                className="absolute inset-0"
                style={{
                    background:
                        'linear-gradient(rgba(38,35,31,0) 0%, rgba(38,35,31,0.82) 72%, rgba(38,35,31,0.92) 100%)',
                }}
            />
            <div className="relative mt-auto flex flex-col items-center gap-5 px-6 pb-[calc(40px+env(safe-area-inset-bottom,0px))] text-center">
                <div className="flex flex-col items-center gap-1.5">
                    <p className="m-0 font-serif text-[22px] leading-[34px] font-bold">
                        {location.state?.line ?? L.exitAlley}
                    </p>
                    <span className="text-[13px] text-[#FFFDF8]/88">{MEMBERS.imo.name}</span>
                </div>
                <button
                    type="button"
                    onClick={() => setWalking(true)}
                    className="h-[54px] w-full rounded-[16px] bg-[#FFFDF8] text-[16px] font-semibold text-brand"
                >
                    가게로 들어가기
                </button>
                <button
                    type="button"
                    onClick={async () => {
                        await logout();
                        navigate('/start', { replace: true });
                    }}
                    className="min-h-11 px-3 text-[13px] text-[#FFFDF8]/88 underline underline-offset-2"
                >
                    다른 계정으로 로그인
                </button>
            </div>
        </main>
    );
}
